import { createAsyncThunk } from "@reduxjs/toolkit";

import { postData, postFormData } from "../../../services";
import { fetchDataAxios } from "../../../apiConfig";

export const saveOrUpdateCaseThunk = createAsyncThunk(
  "/createNewCase",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await postFormData(`/cases/createNewCase`, payload);
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);
export const closeOrReOpenCaseThunk = createAsyncThunk(
  "/saveOrUpdateCase",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await postData(`/cases/saveOrUpdateCase`, {
        ...payload,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const finalStatusListThunk = createAsyncThunk(
  "/finalStatusList",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/finalStatusList`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const typeOfOrderThunk = createAsyncThunk(
  "/typeOfOrder",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/typeOfOrder`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);
